import emptyImage from '~/assets/scss/static/无记录icon@2x@3x.png'

/** 全局「暂无数据」插图 */
export const EMPTY_IMAGE = emptyImage
